import React, { useEffect, useState, useMemo, useCallback } from "react";
import { Table, Input, Select, Tabs, Modal, message, Button, Tooltip, Checkbox, Form, Row, Col } from "antd";
import { DropdownCheckBox } from "atoms/UIDropdown/Dropdown";
import {
  SearchOutlined,
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
  HistoryOutlined,
  CopyOutlined,
} from "@ant-design/icons";
import styled from "styled-components";
import COLORS from "common/Colors";
import { CALL_API, CALL_FEATCH_API } from "common/API";
import { get } from "lodash";
import moment from "moment";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { toggleProcessingModal } from "redux/actions";
import { useSelector } from "react-redux";
import {
  getSelectedDepartmentId,
  getUserRoleId,
  getUserInfo,
  getMenuList,
  getCountryList,
} from "redux/selectors";
import AddTask from "organisms/AddTask";
import EditTask from "organisms/EditTask";
import TaskFilterModal from "./TaskFilterModal";
import TaskTypeStatus from "./TaskTypeStatus";
import AllTasks from "./AllTasks";
import { ReactComponent as ArrowUpRight } from "assets/icons/UI/ArrowUpRight.svg";

const { Option } = Select;

// ── Styled ────────────────────────────────────────────────────────────────────

const TaskWrap = styled.div`
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
    flex-wrap: wrap;
    gap: 10px;
    .btn-task{
        color: #fff!important;
    }
    .typeStatus{
        color: #000000 !important;
        border-color: #000000 !important;
    }
    .typeStatusAlltask{
      color: #00685F !important;
        border-color: #00685F !important;
    }
  }
  .title {
    font-size: 18px;
    font-weight: 600;
    color: ${COLORS.TEXT.PRIMARY};
  }
  .ant-table { border-radius: 8px; }
  .action-icons {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    opacity: 0;
    transition: opacity 0.2s ease;
  }
  .ant-table-tbody > tr:hover .action-icons { opacity: 1; }
  .filters-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      margin-top: 1.5rem;
      margin-bottom: 1rem;
      gap: 10px;
    }
  .total-count {
    font-weight: 600;
    font-size: 16px;
    color: ${COLORS.TEXT.PRIMARY};
  }
  .filters {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
    width: 100%;
  }
  .filter-input { width: 176px; min-width: 176px; max-width: 176px; }
  .filter-input input.ant-input {
    border: none !important;
    box-shadow: none !important;
  }
  .filter-input .ant-input-prefix { margin-right: 6px; }
  .ant-tabs-nav::before { border-bottom: 1px solid #e5e7eb; }
  .ant-tabs-tab { font-size: 14px; color: #6b7280; padding: 8px 0; }
  .ant-tabs-tab-active .ant-tabs-tab-btn { color: #00685F !important; font-weight: 600; }
  .ant-tabs-ink-bar { background: #00685F!important; }
.filter-input .ant-select-selector {
    border-radius: 20px !important;
    min-height: 38px !important;
    height: auto !important;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  /* Checkbox in multi-select dropdown options */
  .filter-input-dropdown .ant-select-item-option {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
  }

  .filter-input-dropdown .ant-select-item-option::before {
    content: "";
    width: 16px;
    height: 16px;
    min-width: 16px;
    border: 1.5px solid #d1d5db;
    border-radius: 4px;
    background: #fff;
    display: inline-block;
    transition: all 0.2s;
  }

  .filter-input-dropdown .ant-select-item-option-selected::before {
    background: #deefee;
    border-color: #deefee;
    background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M3 8l3.5 3.5L13 4' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-size: contain;
  }

  .filter-input-dropdown .ant-select-item-option-state {
    display: none;
  }

.filter-input .ant-select-selector:hover,
.ant-select-focused .ant-select-selector {
  border-color: ${COLORS.PRIMARY} !important;
  box-shadow: none !important;
}
`;

const StyledModal = styled(Modal)`
  .ant-modal-content { border-radius: 12px; }
  .ant-modal-header { border-radius: 12px 12px 0 0; }
`;

const ActionIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 18px;
  background: #deefee;
  color: #00685F;
  transition: opacity 0.15s;
`;

const CancelBtn = styled(Button)`
  && {
    height: 38px;
    padding: 0 24px;
    border-radius: 8px;
    border: 1px solid #a6a7aa;
    color: #374151;
    font-weight: 500;
    background: #fff;
  }

  &&:hover {
    border-color: #9ca3af;
    color: #111827;
    background: #f9fafb;
  }
`;

const ConfirmBtn = styled(Button)`
  && {
    height: 38px;
    padding: 0 28px;
    border-radius: 8px;
    background-color: #00685f;
    border: none;
    color: #ffffff !important;
    font-weight: 600;
  }

  &&:hover,
  &&:focus {
    background-color: #00685f !important;
    color: #ffffff !important;
    border: none;
  }
`;

const StyledSearchInput = styled(Input)`
  width: 200px;
  &.ant-input-affix-wrapper { border-radius: 15px !important; }
  .ant-input-prefix { color: #aaa; }
`;

// ── Constants ─────────────────────────────────────────────────────────────────

const PAGE_LIMIT = 10;

// ── Hardcoded task status options (always available, merged with API-fetched ones)
const HARDCODED_TASK_STATUS_OPTIONS = [
  { label: "Open", value: "Open" },
  { label: "InProgress", value: "InProgress" },
  { label: "Completed", value: "Completed" },
];

// ── Component ─────────────────────────────────────────────────────────────────

function Task({ userRoleId, userInfo, menuList }) {
  const countryList = useSelector(getCountryList);

  const [taskList, setTaskList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("pending");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [addingTask, setAddingTask] = useState(false);
  const [editingTask, setEditingTask] = useState(false);
  const [taskDetails, setTaskDetails] = useState({});
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteRecord, setDeleteRecord] = useState(null);
  const [matterList, setMatterList] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [filterStatus, setFilterStatus] = useState([]);
  const [filterAssignee, setFilterAssignee] = useState([]);
  const [filterPriority, setFilterPriority] = useState([]);
  const [filterCreatedBy, setFilterCreatedBy] = useState([]);
  const [historyModal, setHistoryModal] = useState(false);
  const [historyRecord, setHistoryRecord] = useState(null);
  const [historyData, setHistoryData] = useState([]);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [cloningTask, setCloningTask] = useState(false);
  const [cloneDetails, setCloneDetails] = useState({});
  const [showTypeStatus, setShowTypeStatus] = useState(false);
  const [statusModal, setStatusModal] = useState(false);
  const [statusRecord, setStatusRecord] = useState(null);
  const [newStatus, setNewStatus] = useState(null);
  // ── Seed with hardcoded statuses so they're available immediately, before the API responds ──
  const [statusOptions, setStatusOptions] = useState(HARDCODED_TASK_STATUS_OPTIONS);
  const [showAllTasks, setShowAllTasks] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [viewRecord, setViewRecord] = useState(null);


  const [form] = Form.useForm();

  // Applied filters — driven by TaskFilterModal's onApply callback
  const [appliedFilters, setAppliedFilters] = useState(null);
  const [filterOptions, setFilterOptions] = useState({
    statuses: [], assignees: [], priorities: [], createdBy: [], taskTypes: [],
  });

  const url = useMemo(() => {
    const segments = window.location.pathname.split("/");
    return segments[segments.length - 1];
  }, []);

  const Menulist = menuList[userRoleId] || Object.values(menuList)[0];

  // ── Fetch matter list ─────────────────────────────────────────────────────
  useEffect(() => {
    const fetchMatters = async () => {
      try {
        const res = await CALL_FEATCH_API(
          `insyts-matter/getmatter?userid=${userInfo?.userid}&managingoffice=${userInfo?.managingOffice || countryList[0]?.countryname}&page=1&limit=100`,
          "GET"
        );
        const rawList = res?.response?.data || res?.data || [];
        setMatterList(
          rawList.map((m) => ({
            matterid: m.matterId || m.matterid,
            mattername: m.jobTitle || m.information?.jobTitle || m.mattername || "",
          }))
        );
      } catch (_) { }
    };
    if (userInfo?.userid) fetchMatters();
  }, [userInfo?.userid]);

  const fetchStatuses = useCallback(async () => {
    const res = await CALL_FEATCH_API(`insyts-task/gettaskstatus?userid=${userInfo?.userid}&page=1&limit=500`, "GET");
    if (res?.response?.code === "SUCCESS") {
      const apiStatusOptions = res.response.data.map(s => ({ label: s.statusname, value: s.statusname }));

      // ── Merge hardcoded statuses with API-fetched ones, de-duped by value ──
      const mergedStatusOptions = [...HARDCODED_TASK_STATUS_OPTIONS];
      apiStatusOptions.forEach((opt) => {
        if (!mergedStatusOptions.some((m) => m.value === opt.value)) {
          mergedStatusOptions.push(opt);
        }
      });
      setStatusOptions(mergedStatusOptions);
    } else {
      // API failed or returned nothing — fall back to hardcoded options only
      setStatusOptions(HARDCODED_TASK_STATUS_OPTIONS);
    }
  }, [userInfo?.userid]);

  useEffect(() => {
    if (userInfo?.userid) fetchStatuses();
  }, [userInfo?.userid, fetchStatuses]);

  const fetchFilterOptions = useCallback(async () => {
    const res = await CALL_FEATCH_API(
      `insyts-task/gettask?userid=${userInfo?.userid}&filterdata=true&tab=${activeTab}`,
      "GET"
    );
    if (res?.response?.code === "SUCCESS") {
      setFilterOptions(res.response.data);
    }
  }, [userInfo?.userid, activeTab]);

  useEffect(() => {
    if (userInfo?.userid) fetchFilterOptions();
  }, [userInfo?.userid, activeTab, fetchFilterOptions]);

  const fetchTaskHistory = async (record) => {
    setHistoryLoading(true);
    setHistoryData([]);
    try {
      const res = await CALL_FEATCH_API(
        `insyts-task/gettaskhistory?taskid=${record.taskid}&userid=${userInfo?.userid}`,
        "GET"
      );
      if (res?.response?.code === "SUCCESS") {
        setHistoryData(res.response.data || []);
      }
    } catch (_) { }
    setHistoryLoading(false);
  };

  // ── Fetch tasks ───────────────────────────────────────────────────────────
  const getTaskList = useCallback(
    async (page = 1) => {
      setLoading(true);
      const params = new URLSearchParams({
        userid: userInfo?.userid,
        tab: activeTab,
        page: String(page),
        limit: String(PAGE_LIMIT),
      });

      if (url === "mytask") {
        params.append("assignedto", get(userInfo, "userid", ""));
      }

      // ── Inline filters ────────────────────────────────────────
      if (filterStatus?.length) params.append("taskstatus", filterStatus.join(","));
      if (filterAssignee?.length) params.append("assignedtoname", filterAssignee.join(","));
      if (filterPriority?.length) params.append("priority", filterPriority.join(","));
      if (filterCreatedBy?.length) params.append("createdbyname", filterCreatedBy.join(","));

      // ── TaskFilterModal filters ───────────────────────────────
      if (appliedFilters) {
        if (appliedFilters.tasktype?.length)
          params.append("tasktype", appliedFilters.tasktype.join(","));
        if (appliedFilters.matterid?.length)
          params.append("matterid", appliedFilters.matterid.join(","));
        if (appliedFilters.createdby?.length)
          params.append("createdbyname", appliedFilters.createdby.join(","));
        if (appliedFilters.isprivate !== null && appliedFilters.isprivate !== undefined)
          params.append("isprivate", appliedFilters.isprivate);
        if (appliedFilters.dueDateFrom)
          params.append("duedatefrom", moment(appliedFilters.dueDateFrom).format("YYYY-MM-DD"));
        if (appliedFilters.dueDateTo)
          params.append("duedateto", moment(appliedFilters.dueDateTo).format("YYYY-MM-DD"));
        if (appliedFilters.createdDateFrom)
          params.append("createddatefrom", moment(appliedFilters.createdDateFrom).format("YYYY-MM-DD"));
        if (appliedFilters.createdDateTo)
          params.append("createddateto", moment(appliedFilters.createdDateTo).format("YYYY-MM-DD"));
      }

      const resp = await CALL_FEATCH_API(
        `insyts-task/gettask?${params.toString()}`,
        "GET"
      );

      if (resp?.response?.code === "SUCCESS") {
        setTaskList(resp.response.data || []);
        setTotalCount(
          resp.response.total ?? resp.response.pagination?.total ?? resp.response.data?.length ?? 0
        );
        setCurrentPage(page);
      }
      setLoading(false);
    },
    [userInfo, activeTab, appliedFilters, filterStatus, filterAssignee, filterPriority, filterCreatedBy, url]
  );

  useEffect(() => {
    setCurrentPage(1);
    getTaskList(1);
  }, [activeTab, appliedFilters, filterStatus, filterAssignee, filterPriority, filterCreatedBy]);
  // ── Filter callbacks passed to TaskFilterModal ────────────────────────────
  const handleFilterApply = (filters) => {
    setAppliedFilters(filters);
  };

  const handleFilterClear = () => {
    setAppliedFilters(null);
  };

  const handleFormFilterChange = () => {
    const values = form.getFieldsValue();
    setSearchText(values.search || "");
    setFilterStatus(values.status || []);
    setFilterAssignee(values.assignee || []);
    setFilterPriority(values.priority || []);
    setFilterCreatedBy(values.createdBy || []);
  };

  // ── Client-side search on top of server data ──────────────────────────────
  const displayData = taskList.filter((item) => {
    const matchSearch =
      !searchText?.length ||
      item.taskname?.toLowerCase().includes(searchText.toLowerCase());
    return matchSearch;
  });

  // ── Dropdown options derived from current task list ───────────────────────
  const taskTypeOptions = filterOptions.taskTypes;
  const createdByOptions = displayData.length > 0
    ? [...new Set(displayData.map((item) => item.createdbyname).filter(Boolean))]
    : [];

  // ── CRUD actions ──────────────────────────────────────────────────────────
  const handleEdit = (e, record) => {
    e.stopPropagation();
    setTaskDetails(record);
    setEditingTask(true);
  };

  const handleView = (e, record) => {
    e.stopPropagation();
    setTaskDetails({ ...record, isViewOnly: true });
    setEditingTask(true);
  };

  const handleDelete = (e, record) => {
    e.stopPropagation();
    setDeleteRecord(record);
    setDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    const response = await CALL_API(`insyts-task/deletetask`, "post", {
      taskid: deleteRecord.taskid,
      userid: userInfo?.userid,
      deletedby: get(userInfo, "username", "") || get(userInfo, "userid", ""),
    });
    if (
      response?.code === "SUCCESS" ||
      response?.response?.code === "SUCCESS" ||
      response?.status === "SUCCESS"
    ) {
      message.success("Task deleted successfully.");
      setFilterOptions({ statuses: [], assignees: [], priorities: [], createdBy: [], taskTypes: [] });
      getTaskList(currentPage);
      fetchFilterOptions();
    } else {
      message.error("Failed to delete task. Please try again.");
    }
    setDeleteModal(false);
    setDeleteRecord(null);
  };

  const handleClone = async (record) => {
    const response = await CALL_API("insyts-task/clonetask", "post", {
      taskid: record.taskid,
      userid: userInfo?.userid,
      clonedby: get(userInfo, "username", ""),
    });
    if (response?.response?.code === "SUCCESS") {
      message.success("Task cloned successfully.");
      getTaskList(currentPage);
    } else {
      message.error("Failed to clone task.");
    }
  };
  const handleStatusUpdate = async () => {
    const response = await CALL_API("insyts-task/edittask", "post", {
      taskid: statusRecord.taskid,
      userid: userInfo?.userid,
      userName: userInfo?.name || null,
      taskstatus: newStatus,
      updatedby: get(userInfo, "userid", ""),
      statusOnly: true,
    });

    if (response?.code === "SUCCESS" || response?.response?.code === "SUCCESS") {
      message.success("Status updated successfully.");
      setFilterOptions({ statuses: [], assignees: [], priorities: [], createdBy: [], taskTypes: [] });
      getTaskList(currentPage);
      fetchFilterOptions();
    } else {
      message.error("Failed to update status.");
    }
    setStatusModal(false);
    setStatusRecord(null);
    setNewStatus(null);
  };

  const handleDeleteCancel = () => {
    setDeleteModal(false);
    setDeleteRecord(null);
  };

  // ── Columns ───────────────────────────────────────────────────────────────
  const columns = [
    { title: "Name", dataIndex: "taskname" },
    {
      title: "Created by",
      render: (_, record) => (
        <div>
          <div style={{ fontSize: 14, color: "#111827" }}>
            {record.createdbyname || "N/A"}
          </div>
          <small style={{ fontSize: 12, color: "#6b7280", fontStyle: "italic" }}>
            {record.createdat ? moment(record.createdat).format("Do MMM, YYYY") : ""}
          </small>
        </div>
      ),
    },
    { title: "Assigned to", dataIndex: "assignedtoname" },
    { title: "Priority", dataIndex: "priority" },
    ...(activeTab === "pending"
      ? [{ title: "Status", dataIndex: "taskstatus" }]
      : []),
    { title: "Type", dataIndex: "tasktype" },
    { title: "Matter", dataIndex: "mattername" },
    {
      title: "Action",
      key: "action",
      width: 160,
      render: (_, record) => {
        const isCreator = record.createdby === userInfo?.userid
        const isAssignee = record.assignedto === userInfo?.userid

        return (
          <div className="action-icons">
            {url === "mytask" &&
              Menulist?.find((item) => item.title === "My Task" && item.permission?.view) && (
                <Tooltip title="View">
                  <ActionIcon
                    onClick={(e) => handleView(e, record)}>
                    <EyeOutlined />
                  </ActionIcon>
                </Tooltip>
              )}

            {url !== "mytask" && (
              <>
                {/* History — creator or assignee */}
                {(isCreator || isAssignee) && (
                  <Tooltip title="History">
                    <ActionIcon
                      onClick={(e) => {
                        e.stopPropagation();
                        setHistoryRecord(record);
                        setHistoryModal(true);
                        fetchTaskHistory(record);
                      }}>
                      <HistoryOutlined />
                    </ActionIcon>
                  </Tooltip>
                )}

                {/* Clone — creator or assignee */}
                {(isCreator || isAssignee) && (
                  <Tooltip title="Clone">
                    <ActionIcon
                      onClick={(e) => {
                        e.stopPropagation();
                        setCloneDetails(record);
                        setCloningTask(true);
                      }}>
                      <CopyOutlined />
                    </ActionIcon>
                  </Tooltip>
                )}

                {/* Edit — creator only, always visible */}
                {isCreator &&
                  Menulist?.find((item) => item.title === "Task" && item.permission?.edit) && (
                    <Tooltip title="Edit">
                      <ActionIcon
                        onClick={(e) => handleEdit(e, record)}>
                        <EditOutlined />
                      </ActionIcon>
                    </Tooltip>
                  )}

                {/* Delete — creator only, always visible */}
                {isCreator &&
                  Menulist?.find((item) => item.title === "Task" && item.permission?.delete) && (
                    <Tooltip title="Delete">
                      <ActionIcon
                        onClick={(e) => handleDelete(e, record)}>
                        <DeleteOutlined />
                      </ActionIcon>
                    </Tooltip>
                  )}

                {/* Update Status — assignee only (includes creator+assignee), always visible */}
                {isAssignee && (
                  <Tooltip title="Update Status">
                    <ActionIcon

                      style={{
                        width: "auto", padding: "0 12px",
                        fontSize: 12, fontWeight: 600, whiteSpace: "nowrap",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setStatusRecord(record);
                        setNewStatus(record.taskstatus);
                        fetchStatuses();
                        setStatusModal(true);
                      }}
                    >
                      Update Status
                    </ActionIcon>
                  </Tooltip>
                )}
              </>
            )}
          </div>
        );
      },
    },
  ];

  const tabItems = [
    { key: "pending", label: "Pending" },
    { key: "completed", label: "Completed" },
  ];

  // ── Render ────────────────────────────────────────────────────────────────
  return (

    <>
      {showTypeStatus ? (
        <TaskTypeStatus onBack={() => setShowTypeStatus(false)} />
      ) : showAllTasks ? (
        <AllTasks onBack={() => setShowAllTasks(false)} />
      ) : (
        <TaskWrap>
          {/* Header */}
          <div className="header">
            <div className="title">Tasks</div>
            <div className="d-flex gap-4 mb-3">

              <span className="typeStatusAlltask"
                onClick={() => setShowAllTasks(true)}
                style={{
                  fontSize: 14,
                  fontWeight: 500,
                  cursor: "pointer",
                  color: "#111827",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 4
                }}
              >
                All Tasks
                <ArrowUpRight width={24} height={24} />
              </span>

              <Button className="typeStatus"
                style={{ borderRadius: "6px", border: "1px solid black" }}
                onClick={() => setShowTypeStatus(true)}
              >
                Type &amp; Status
              </Button>
              {url !== "mytask" &&
                Menulist?.find(
                  (item) => item.title === "Task" && item.permission?.create
                ) && (
                  <Button
                    className="btn-task"
                    // type="primary"
                    style={{ background: COLORS.PRIMARY, borderRadius: "6px" }}
                    onClick={() => setAddingTask(true)}
                  >
                    Create Task
                  </Button>
                )}
            </div>
          </div>

          {/* Tabs */}
          <Tabs
            activeKey={activeTab}
            onChange={(key) => {
              setActiveTab(key);
              setSearchText("");
              setAppliedFilters(null);
              setFilterStatus([]);
              setFilterAssignee([]);
              setFilterPriority([]);
              setFilterCreatedBy([]);
              form.resetFields();
            }}
            items={tabItems}
            style={{ marginBottom: 0 }}
          />

          {/* Filters row */}
          <div className="filters-header">
            <div className="total-count">
              Total {activeTab === "pending" ? "Pending" : "Completed"}: {totalCount}
            </div>
            <Form form={form} layout="vertical" onValuesChange={handleFormFilterChange}>
              <Row gutter={12} align="bottom" wrap>
                <Col>
                  <div style={{ width: 200 }}>
                    <Form.Item name="search" style={{ margin: 0, marginBottom: 16 }}>
                      <StyledSearchInput
                        placeholder="Search"
                        prefix={<SearchOutlined />}
                        allowClear
                      />
                    </Form.Item>
                  </div>
                </Col>

                {activeTab === "pending" && (
                  <Col>
                    <div style={{ width: 200 }}>
                      <DropdownCheckBox
                        name="status"
                        label="Status"
                        options={filterOptions?.statuses?.filter((s) => s?.toLowerCase() !== "completed").map((s) => ({ label: s, value: s })) || []}
                        form={form}
                        handleFormChange={handleFormFilterChange}
                      />
                    </div>
                  </Col>
                )}

                <Col>
                  <div style={{ width: 200 }}>
                    <DropdownCheckBox
                      name="assignee"
                      label="Assignee"
                      options={filterOptions?.assignees?.map((a) => ({ label: a, value: a })) || []}
                      form={form}
                      handleFormChange={handleFormFilterChange}
                    />
                  </div>
                </Col>

                <Col>
                  <div style={{ width: 200 }}>
                    <DropdownCheckBox
                      name="priority"
                      label="Priority"
                      options={filterOptions?.priorities?.map((p) => ({ label: p, value: p })) || []}
                      form={form}
                      handleFormChange={handleFormFilterChange}
                    />
                  </div>
                </Col>

                <Col>
                  <TaskFilterModal
                    taskTypeOptions={taskTypeOptions}
                    matterOptions={matterList}
                    createdByOptions={createdByOptions}
                    onApply={handleFilterApply}
                    onClear={handleFilterClear}
                  />
                </Col>
              </Row>
            </Form>
          </div>

          {/* Table */}
          <Table
            columns={columns}
            dataSource={displayData}
            loading={loading}
            rowKey="taskid"
            size="small"
            onRow={(record) => ({
              onClick: () => {
                setViewRecord(record);
                setViewModal(true);
              },
              style: { cursor: "pointer" },
            })}
            pagination={{
              current: currentPage,
              pageSize: PAGE_LIMIT,
              total: totalCount,
              onChange: (page) => getTaskList(page),
              showSizeChanger: false,
              showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} tasks`,
            }}
          />

          {/* Delete Modal */}
          <StyledModal
            visible={deleteModal}
            onCancel={handleDeleteCancel}
            footer={null}
            width={420}
            closable={false}
            centered
            destroyOnClose
          >
            <div style={{ textAlign: "center", padding: "24px 16px 8px" }}>
              <p style={{ fontSize: 15, fontWeight: 500, color: "#111827", marginBottom: 32 }}>
                Are you sure you want to delete this Task?
              </p>
              <div style={{ display: "flex", justifyContent: "center", gap: 16 }}>
                <CancelBtn onClick={handleDeleteCancel} style={{ width: 120 }}>No</CancelBtn>
                <ConfirmBtn onClick={handleDeleteConfirm} style={{ width: 120 }}>Yes</ConfirmBtn>
              </div>
            </div>
          </StyledModal>

          {/* Add Modal */}
          <AddTask
            isModalVisible={addingTask}
            closeModal={(success) => { setAddingTask(false); if (success) { message.success("Task created successfully."); fetchFilterOptions(); } }}
            getTaskList={getTaskList}
            title="Add New Task"
            taskDetails={{}}
            matterList={matterList}
          />

          {/* Edit Modal */}
          <EditTask
            isModalVisible={editingTask}
            closeModal={(success) => { setEditingTask(false); if (success) { message.success("Task updated successfully."); fetchFilterOptions(); } }}
            getTaskList={getTaskList}
            title="Edit Task"
            taskDetails={taskDetails}
          />

          {/* Clone Modal */}
          <AddTask
            isModalVisible={cloningTask}
            closeModal={(success) => { setCloningTask(false); setCloneDetails({}); if (success) { message.success("Task cloned successfully."); fetchFilterOptions(); } }}
            getTaskList={getTaskList}
            title="Clone Task"
            isClone={true}
            cloneData={cloneDetails}
            matterList={matterList}
          />

          {/* History Modal */}
          <StyledModal
            visible={historyModal}
            onCancel={() => { setHistoryModal(false); setHistoryRecord(null); setHistoryData([]); }}
            footer={null}
            width={600}
            title="Task History"
            destroyOnClose
          >
            <div style={{
              border: "1px solid #f0f0f0",
              borderRadius: 10,
              overflow: "hidden",
            }}>
              {/* Header row */}
              <div style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                background: "#f9fafb",
                padding: "12px 20px",
                fontWeight: 600,
                fontSize: 14,
                color: "#374151",
                borderBottom: "1px solid #f0f0f0",
              }}>
                <span>Action by</span>
                <span>Date &amp; Time</span>
              </div>

              {/* Rows */}
              {historyLoading ? (
                <div style={{ textAlign: "center", padding: "32px 0", color: "#888" }}>
                  Loading...
                </div>
              ) : historyData.length === 0 ? (
                <div style={{ textAlign: "center", padding: "32px 0", color: "#888", fontSize: 14 }}>
                  No history available.
                </div>
              ) : (
                historyData.map((h, i) => (
                  <div key={i} style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    padding: "16px 20px",
                    borderBottom: i < historyData.length - 1 ? "1px solid #f5f5f5" : "none",
                    fontSize: 14,
                    color: "#6b7280",
                    background: "#fff",
                  }}>
                    <span>
                      {h.action === "Updated status by" ? "Status Updated by" : h.action}{" "}
                      <strong style={{ color: "#111827" }}>{h.actionbyname || 'N/A'}</strong>
                    </span>
                    <span style={{ color: "#6b7280" }}>
                      {h.actionat
                        ? moment(h.actionat).format("Do MMM YYYY; hh:mm A")
                        : "—"}
                    </span>
                  </div>
                ))
              )}
            </div>
          </StyledModal>

          <StyledModal
            visible={viewModal}
            onCancel={() => { setViewModal(false); setViewRecord(null); }}
            footer={null}
            width={520}
            destroyOnClose
            title={
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", paddingRight: 24 }}>
                <span style={{ fontWeight: 700, fontSize: 16 }}>Task Details</span>
                <div style={{ display: "flex", alignItems: "center", gap: 10, marginRight: 15 }}>

                  {(() => {
                    const isCreator = viewRecord?.createdby === userInfo?.userid;
                    const isAssignee = viewRecord?.assignedto === userInfo?.userid;

                    return (
                      <>
                        {/* History — creator or assignee */}
                        {(isCreator || isAssignee) && (
                          <Tooltip title="History">
                            <ActionIcon
                              onClick={(e) => {
                                e.stopPropagation();
                                setHistoryRecord(viewRecord);
                                setHistoryModal(true);
                                fetchTaskHistory(viewRecord);
                                setViewModal(false);
                              }}>
                              <HistoryOutlined />
                            </ActionIcon>
                          </Tooltip>
                        )}

                        {/* Clone — creator or assignee */}
                        {(isCreator || isAssignee) && (
                          <Tooltip title="Clone">
                            <ActionIcon
                              onClick={(e) => {
                                e.stopPropagation();
                                setCloneDetails(viewRecord);
                                setCloningTask(true);
                                setViewModal(false);
                              }}>
                              <CopyOutlined />
                            </ActionIcon>
                          </Tooltip>
                        )}

                        {/* Edit — creator only, always visible */}
                        {isCreator &&
                          Menulist?.find((item) => item.title === "Task" && item.permission?.edit) && (
                            <Tooltip title="Edit">
                              <ActionIcon
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setTaskDetails(viewRecord);
                                  setEditingTask(true);
                                  setViewModal(false);
                                }}>
                                <EditOutlined />
                              </ActionIcon>
                            </Tooltip>
                          )}

                        {/* Delete — creator only, always visible */}
                        {isCreator &&
                          Menulist?.find((item) => item.title === "Task" && item.permission?.delete) && (
                            <Tooltip title="Delete">
                              <ActionIcon
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setDeleteRecord(viewRecord);
                                  setDeleteModal(true);
                                  setViewModal(false);
                                }}>
                                <DeleteOutlined />
                              </ActionIcon>
                            </Tooltip>
                          )}

                        {/* Update Status — assignee only (includes creator+assignee), always visible */}
                        {isAssignee && (
                          <ActionIcon

                            style={{ width: "auto", padding: "0 12px", fontSize: 12, fontWeight: 600, whiteSpace: "nowrap" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              setStatusRecord(viewRecord);
                              setNewStatus(viewRecord.taskstatus);
                              fetchStatuses();
                              setStatusModal(true);
                              setViewModal(false);
                            }}
                          >
                            Update Status
                          </ActionIcon>
                        )}
                      </>
                    );
                  })()}

                </div>
              </div>
            }
          >
            {viewRecord && (
              <div style={{ fontSize: 14 }}>
                {[
                  { label: "Name of the Task", value: viewRecord.taskname },
                  { label: "Priority", value: viewRecord.priority },
                  { label: "Task Status", value: viewRecord.taskstatus },
                  { label: "Created by", value: `${viewRecord.createdbyname || ""}${viewRecord.createdat ? "; " + moment(viewRecord.createdat).format("Do MMM YYYY") : ""}` },
                  { label: "Assigned to", value: viewRecord.assignedtoname },
                  { label: "Due Date & Time", value: `${viewRecord.duedate ? moment(viewRecord.duedate).format("Do MMM YYYY") : ""}${viewRecord.duetime ? "; " + moment(viewRecord.duetime, "HH:mm").format("hh:mm A") : ""}` },
                  { label: "Task Type", value: viewRecord.tasktype },
                  { label: "Matter", value: viewRecord.mattername },
                  { label: "Estimated Time of Completion", value: viewRecord.estimatedtime },
                ].map(({ label, value }) =>
                  value ? (
                    <div key={label} style={{ display: "flex", padding: "10px 0" }}>
                      <span style={{ width: 200, color: "#6b7280", flexShrink: 0 }}>{label}</span>
                      <span style={{ color: "#111827", fontWeight: 500 }}>{value}</span>
                    </div>
                  ) : null
                )}

                {/* Description */}
                {viewRecord.description && (
                  <div style={{ paddingTop: 14 }}>
                    <div style={{ color: "#6b7280", marginBottom: 6 }}>Task Description</div>
                    <div style={{ color: "#111827", lineHeight: 1.7 }}>{viewRecord.description}</div>
                  </div>
                )}
              </div>
            )}
          </StyledModal>


          <StyledModal
            visible={statusModal}
            onCancel={() => { setStatusModal(false); setStatusRecord(null); setNewStatus(null); }}
            footer={null}
            width={480}
            title="Update Status"
            destroyOnClose
            centered
          >
            <div style={{ padding: "24px 16px 8px" }}>
              <Select
                style={{ width: "100%", borderRadius: 8 }}
                value={newStatus}
                onChange={(val) => setNewStatus(val)}
                getPopupContainer={(trigger) => trigger.parentElement}
              >
                {statusOptions.map((s) => (
                  <Option key={s.value} value={s.value}>{s.label}</Option>
                ))}
              </Select>

              <div style={{ display: "flex", justifyContent: "flex-end", gap: 16, marginTop: 32 }}>
                <CancelBtn style={{ width: 120 }} onClick={() => { setStatusModal(false); setStatusRecord(null); setNewStatus(null); }}>
                  Cancel
                </CancelBtn>
                <ConfirmBtn style={{ width: 120 }} onClick={handleStatusUpdate}>
                  Update
                </ConfirmBtn>
              </div>
            </div>
          </StyledModal>

        </TaskWrap>
      )}
    </>
  );
}

const mapStateToProps = (state) => ({
  userRoleId: getUserRoleId(state),
  selectedDepartmentId: getSelectedDepartmentId(state),
  userInfo: getUserInfo(state),
  menuList: getMenuList(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ updateProcessingModal: toggleProcessingModal }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Task);